import React, { useState, useRef } from 'react';
import { FaCreditCard, FaMoneyBillWave, FaExchangeAlt, FaCalculator, FaCalendarAlt, FaMoneyBill } from 'react-icons/fa';
import { FaCashRegister } from 'react-icons/fa';
import Layout from '../components/Layout';

const Caixa = () => {
    const [startDate, setStartDate] = useState(new Date());
    const dateInputRef = useRef(null);
    const isMobile = window.innerWidth < 768;
 
  // Função para formatar data como DD/MM/YYYY
    const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

    const handleDateChange = (e) => {
    // Pega a string no formato YYYY-MM-DD
    const dateString = e.target.value;
    
    // Cria a data no fuso horário local
    const [year, month, day] = dateString.split('-');
    const localDate = new Date(year, month - 1, day);
    
    setStartDate(localDate);
    };

    const triggerDatePicker = () => {
        dateInputRef.current.showPicker();
    };

 return (
    <Layout title="Caixa" icon={FaCalculator}>
      <div style={styles.container}>
        <div style={styles.dateSection}>
          <div style={styles.dateContainer}>
            <FaCalendarAlt style={styles.calendarIcon} />
            <span style={styles.dateTitle}>Data selecionada:</span>
            <span style={styles.dateDisplay}>{formatDate(startDate)}</span>
            
            <div style={styles.dateInputWrapper}>
              <input
                type="date"
                ref={dateInputRef}
                value={startDate.toISOString().split('T')[0]}
                onChange={handleDateChange}
                style={styles.hiddenDateInput}
              />
              <button 
                onClick={triggerDatePicker}
                style={styles.dateButton}
              >
                Selecionar data
              </button>
            </div>
          </div>
        </div>
      
      {/* Cards Financeiros */}
      <div style={styles.cardContainer}>
        {/* Card Recargas feitas por cartão de crédito */}
        <div style={styles.creditcardCard}>
          <div style={styles.cardHeader}>
            <FaCreditCard style={styles.cardIcon} />
            <h3 style={styles.cardTitle}>Recargas cartão de CRÉDITO</h3>
          </div>
          <p style={styles.cardValue}>R$ 2000,00</p>
          <button style={styles.cardButton}>VER EXTRATO</button>
        </div>
        
        {/* Card Recargas feitas por cartão de débito */}
        <div style={styles.debitcardCard}>
          <div style={styles.cardHeader}>
            <FaCreditCard style={styles.cardIcon} />
            <h3 style={styles.cardTitle}>Recargas cartão de DÉBITO</h3>
          </div>
          <p style={styles.cardValue}>R$ 200,00</p>
          <button style={styles.cardButton}>VER EXTRATO</button>
        </div>
        
        {/* Card Recargas feitas em dinheiro */}
        <div style={styles.moneyCard}>
          <div style={styles.cardHeader}>
            <FaMoneyBill style={styles.cardIcon} />
            <h3 style={styles.cardTitle}>Recargas em PIX</h3>
          </div>
          <p style={styles.cardValue}>R$ 1500,00</p>
          <button style={styles.cardButton}>VER EXTRATO</button>
        </div>

        {/* Card Recargas feitas por pix
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <FaMoneyBillWave style={styles.cardIcon} />
            <h3 style={styles.cardTitle}>Recargas por PIX</h3>
          </div>
          <p style={styles.cardValue}>R$ 800,00</p>
          <button style={styles.cardButton}>VER EXTRATO</button>
        </div> */}

        {/* Card Total de recargas */}
        <div style={styles.totalCard}>
          <div style={styles.cardHeader}>
            <FaCalculator style={styles.cardIcon} />
            <h3 style={styles.cardTitle}>TOTAL de recargas</h3>
          </div>
          <p style={styles.cardValue}>R$ 4500,00</p>
          <button style={styles.cardButton}>VER DETALHES</button>
        </div>
      </div>
    </div>
    </Layout>
  );
};

// Estilos estáticos
const styles = {
  container: {
    margin: '0 auto',
    fontFamily: 'Montserrat, sans-serif',
    maxWidth: '1200px',
    padding: '0 15px',
  },
  dateSection: {
    backgroundColor: '#f8f9fa',
    borderRadius: '10px',
    padding: '15px',
    margin: '15px 0',
    boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
  },
  dateContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    flexWrap: 'wrap',
  },
  calendarIcon: {
    color: '#09448C',
    fontSize: '20px',
  },
  dateTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#555',
  },
  dateDisplay: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#09448C',
    minWidth: '100px',
  },
  dateInputWrapper: {
    position: 'relative',
  },
  hiddenDateInput: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: '0',
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    border: '0',
  },
  dateButton: {
    backgroundColor: '#09448C',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'background-color 0.2s',
  },
  
  cardContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '20px',
    margin: '20px 0',
  },

  card: {
    backgroundColor: '#fff',
    borderRadius: '10px',
    padding: '20px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.3s, box-shadow 0.3s',
  },

  creditcardCard: {
    backgroundColor: '#fffdef',
    borderRadius: '10px',
    padding: '20px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    transition: 'transform 0.3s, box-shadow 0.3s',

    },

  debitcardCard: {
    backgroundColor: '#ffeebb80',
    borderRadius: '10px',
    padding: '20px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    transition: 'transform 0.3s, box-shadow 0.3s',
  },

    moneyCard: {
    backgroundColor: '#e3ffea',
    borderRadius: '10px',
    padding: '20px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    transition: 'transform 0.3s, box-shadow 0.3s',
  },

  totalCard: {
    backgroundColor: 'rgb(248, 249, 250)',
    borderRadius: '10px',
    padding: '20px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    transition: 'transform 0.3s, box-shadow 0.3s',
  },

  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '15px',
  },

  cardIcon: {
    color: '#09448C',
    fontSize: '22px',
    marginRight: '12px',
  },

  cardTitle: {
    fontSize: '16px',
    fontWeight: '600',
    margin: '0',
    color: '#333',
  },

  cardValue: {
    fontSize: '26px',
    fontWeight: '700',
    margin: '10px 0 20px 0',
    color: '#09448C',
  },

  cardButton: {
    backgroundColor: 'transparent',
    color: '#09448C',
    border: '1px solid #09448C',
    borderRadius: '6px',
    padding: '10px 16px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    transition: 'all 0.3s',
  },

  sectionDivider: {
    height: '1px',
    backgroundColor: '#eee',
    margin: '30px 0',
  },

  mobileContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 0',
    width: '100%',
  },
  
  desktopContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 0',
    width: '100%',
  },
};

export default Caixa;